require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-gr-8-paper-push.json") })
        }
      }, "path---es-articles-tags-gr-8-paper-push");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-gr-8-paper-push!./.cache/json/es-articles-tags-gr-8-paper-push.json
// module id = 2337
// module chunks = 231608221292675